<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-25 09:56:34
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveCanaelReason\editLeaveCanaelReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-23 17:44:21
-->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_leaveCancelReason_from_editTitle')
        : $t('label_essweb_leaveCancelReason_from_viewTitle')
    "
    widthClass="max-1000"
    delBtn
    backgroundClass="white"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    :initData="leaveCancelData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'leave_reason_name',
      'leave_reason_code',
      'leave_reason_description',
      'sequence',
      'remarks',
    ]"
    @delete="
      $confirmDo($t('label_essweb_leaveCancelReason_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-container fluid class="pa-0">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <inputTextFiledMultiLang
                maxlength="100"
                :filled="iSEdited"
                :readonly="!iSEdited"
                :bindData="leaveCancelData.leave_reason_name"
                @change="
                  (valueArr) => {
                    leaveCancelData.leave_reason_name = valueArr;
                  }
                "
                :label="
                  $t(
                    'label_essweb_leaveCancelReason_from_leaveCancelReasonNameLabel'
                  )
                "
                :rules="$GetRules(['_Require_Rules'], [null])"
              />
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <normalInputTextFiled
                type="number"
                :filled="iSEdited"
                :rules="
                  $GetRules(['_Number_negative', '_Length_Rules'], [null, 10])
                "
                maxlength="10"
                isNotRequire
                :readonly="!iSEdited"
                :label="$t('label_essweb_leaveCancelReason_from_sequenceLabel')"
                v-model="leaveCancelData.sequence"
              />
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <normalInputTextFiled
                :filled="iSEdited"
                :readonly="!iSEdited"
                :label="$t('label_essweb_leaveCancelReason_from_codeLabel')"
                :rules="$GetRules(['_Require_Rules'], [null])"
                maxlength="50"
                v-model="leaveCancelData.leave_reason_code"
              />
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <inputTextFiledMultiLang
                :filled="iSEdited"
                :readonly="!iSEdited"
                :bindData="leaveCancelData.leave_reason_description"
                maxlength="500"
                @change="
                  (valueArr) => {
                    leaveCancelData.leave_reason_description = valueArr;
                  }
                "
                :label="
                  $t('label_essweb_leaveCancelReason_from_descriptionLabel')
                "
              />
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <v-sheet class="text--secondary">{{
                $t("label_essweb_leaveCancelReason_from_remarkLabel")
              }}</v-sheet>
              <v-textarea
                rows="5"
                no-resize
                maxlength="500"
                :filled="iSEdited"
                :readonly="!iSEdited"
                dense
                counter="500"
                single-line
                v-model="leaveCancelData.remarks"
                name="input-7-4"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        saveBtn
        @save="toSave"
        @cancel="$toBack(isChanged)"
        v-if="iSEdited"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main></template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newLeaveCanaelReason",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      iSEdited: true,
      showDelete: false,
      isChanged: false,
      leaveCancelData: {
        leave_reason_name: "",
        leave_reason_code: "",
        leave_reason_description: "",
        sequence: 1,
        remarks: "",
      },
      data_save: null,
    };
  },
  mounted() {
    // this.leaveCancelData.leave_reason_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.leaveCancelData.leave_reason_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getDetail();
  },
  methods: {
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_cancel_reason",
        url: "/leave-cancellation-reason/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["leave_reason_name_save"] = res.data.leave_reason_name;
        res.data.leave_reason_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.leave_reason_name
        );
        res.data["leave_reason_description_save"] =
          res.data.leave_reason_description;
        res.data.leave_reason_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.leave_reason_description
        );
        that.data_save = res.data;
        that.leaveCancelData = res.data;
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_cancel_reason",
        url: "/leave-cancellation-reason/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveCancelReason_list_deleteLeaveCancelReasonSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      // console.log(this.leaveCancelData.leave_reason_name);
      // console.log(this.leaveCancelData.leave_reason_name_save);
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_cancel_reason",
        url: "/leave-cancellation-reason/update/",
        data: {
          uuid: this.$route.params.id,
          leave_reason_name: this.$transCommonLangKey(
            this.leaveCancelData.leave_reason_name,
            this.leaveCancelData.leave_reason_name_save
          ),
          leave_reason_description: this.$transCommonLangKey(
            this.leaveCancelData.leave_reason_description,
            this.leaveCancelData.leave_reason_description_save
          ),
          leave_reason_code: this.leaveCancelData.leave_reason_code,
          sequence: this.leaveCancelData.sequence,
          remarks: this.leaveCancelData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveCancelReason_list_updateLeaveCancelReasonSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
  },
};
</script>
